var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('Mobile'):_c('PC')
}
var staticRenderFns = []

export { render, staticRenderFns }